import React from 'react';

import http from 'api/http';
import {manufacturerAPI} from 'api/requests';

import { Route, Switch } from 'react-router-dom';
import WithUser from 'HOC/User';
import { ROUTE } from 'constants/routing';

import NotFoundScene from 'Scenes/NotFoundScene';
import FormulaModule from './formula';
import OilBranderRouter from './brand';
import { ROLES } from 'constants/roles';

@WithUser
class OilManufacturerRouter extends React.Component {
  updateUserRole = role => {
    const {user} = this.props;

    if (role !== user.getActiveRole()) {
      user.setActiveRole(role);
    }
  };

  componentDidMount = () => {
    http.get(manufacturerAPI.addressesList(this.props.user.getManufacturerCode()))
      .then(({data}) => {
        this.manufacturerAddresses = data.map(addressObject => {
          return ({
            name: [
              addressObject.Address1,
              addressObject.Address2,
              addressObject.Address3,
              addressObject.Address4,
              addressObject.City,
              addressObject.State,
              addressObject.PostalCode,
              addressObject.Country,
            ].filter(object => object).join(', '),
            value: {
              address1: addressObject.Address1,
              address2: addressObject.Address2,
              address3: addressObject.Address3,
              address4: addressObject.Address4,
              city: addressObject.City,
              country: addressObject.Country,
              countryId: addressObject.CountryId,
              postalCode: addressObject.PostalCode,
              state: addressObject.State,
            }
          });
        });
        this.forceUpdate();
      });
  };

  renderScene = (Scene) => {
    return () => {
      const {user, location, history} = this.props;
      return (
        <Scene
          user={user}
          location={location}
          history={history}
          updateUserRole={this.updateUserRole}
          manufacturerAddresses={this.manufacturerAddresses}
        />
      );
    };
  };

  render() {
    return (
      <Switch>
        <Route
          path={`${ROUTE.OIL_MANUFACTURER}${ROLES.OIL_MANUFACTURER.listSceneUrlPostfix}`}
          render={this.renderScene(FormulaModule)}
        />
        <Route
          path={`${ROUTE.OIL_BRANDER}${ROLES.OIL_BRANDER.listSceneUrlPostfix}`}
          render={this.renderScene(OilBranderRouter)}
        />
        <Route render={this.renderScene(NotFoundScene)} />
      </Switch>
    );
  }
}

export default OilManufacturerRouter;



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/index.jsx